<template>
  <v-card class="main-content-card" id="inte-intellectualCheck-card">
    <v-toolbar flat>
      <v-toolbar-title>知识产权登记审核</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12>

        <v-tooltip top>
          <v-chip small label class="mx-0" slot="activator"
                  :color="item.status.color"
                  @click="() => { history=item.history; hist = true; }">
            {{ item.status.name }}
          </v-chip>
          <span>点击查看审核历史</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { reviewDbid = item.dbid; reviewMsg = item.name; reviewActs = item.actions; review = true; }"
                 :disabled="reviewDisabled(item)">
            <v-icon color="teal">playlist_add_check</v-icon>
          </v-btn>
          <span>审核</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="prev">
            <v-icon color="teal">publish</v-icon>
          </v-btn>
          <span>返回</span>
        </v-tooltip>
        <x-review
          v-model="review"
          :dbid="reviewDbid"
          :message="reviewMsg"
          :uri="uri"
          :actions="reviewActs"
          @ok="(it) => Object.assign(item,it)"
        />

        <x-history
          v-model="hist"
          :history="history"
          :status="statusItems"
        />
      </v-flex>

      <v-flex xs12>
        <x-view :inteRegist="item"/>
      </v-flex>
    </v-layout>
  </v-container>
  </v-card>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  import XView from './regist/basic'
  import XReview from '@/components/global/Review'
  import XHistory from '@/components/global/History'

  const baseUri = '/api/inte/intellectualRegist';
  const statusUri = '/api/code/status';
  const deptUri = '/api/syst/department';
  const inteTypeUri = '/api/inte/intellectualType'
  export default {
    components: {XReview, XHistory, XView},

    data: () => ({
      uri: baseUri,
      item: {
        histories: [],
        status: {},
        actions: []
      },

      fileUri: '/api/inte/file',

      statusItems: [],

      review: false,
      reviewDbid: null,
      reviewMsg: null,
      reviewActs: [],

      hist: false,
      history: [],

    }),

    // 路由进入前，组件就未完成渲染，不可以使用 this
    beforeRouteEnter(to, from, next) {
      window.console.log("In edit_page beforeRouteEnter");
      const dbid = to.params.dbid;

      if (dbid) {
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => next(vm => {
              vm.dbid = dbid;
              vm.item = rsp.data;
              // 保存默认数据
              vm.defaultItem = window.xutil.clone(vm.item);
              vm.loading = false
            })
          )
      } else {
        next();
      }
    },

    // 路由改变前，组件就已经渲染完成，可以使用 this
    beforeRouteUpdate(to, from, next) {
      window.console.log("In edit_page beforeRouteUpdate");

      const dbid = to.params.dbid;
      if (dbid) {
        this.loading = true;
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => {
              this.dbid = dbid;
              this.item = rsp.data;
              // 保存默认数据
              this.defaultItem = window.xutil.clone(this.item);
              this.loading = false;
              next()
            }
          )
      } else {
        next();
      }
    },

    computed: {
      ...mapGetters(['funcIds'])
    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
        this.axios.get(inteTypeUri, {params: {sort: 'order.asc'}}),
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
      ]).then(
        this.axios.spread(
          (rspStaus,rspType, rspDept) => {
            this.statusItems = rspStaus.data.items;
            this.typeItems =rspType.data.items;
            this.deptItems = rspDept.data.items;
          }
        )
      )
    },

    methods: {
      reviewDisabled(item) {
        return !(
          // 当前用户拥有审核功能
          this.funcIds.includes('u_inteApp_review')
          // 并且，当前记录需要审核
          && item.actions.find(a => ['approve', 'return', 'revoke'].includes(a.action)))
      },
      prev(){
        this.$router.go(-1)
      }
    }
  }
</script>
<style>
  div.dense table.datatable.table td:first-child,
  div.dense table.datatable.table td:not(:first-child),
  div.dense table.datatable.table th:first-child,
  div.dense table.datatable.table th:not(:first-child) {
    padding: 0 8px;
  }
</style>
